import React from 'react';
import { Check } from 'lucide-react';
export function PainSection() {
  const painPoints = ['Te levantás con el vientre plano, pero después del almuerzo ya tenés que desabrocharte el pantalón.', 'Probás dietas estrictas, bajás un kilo, pero la hinchazón abdominal nunca se va.', 'Sentís pesadez y falta de energía, como si tu cuerpo estuviera luchando para digerir.', 'Pensás que es "normal por la edad" o que simplemente tu metabolismo se volvió lento.'];
  return <section className="py-14 bg-white relative overflow-hidden" data-id="element-368">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-369">
        <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center max-w-7xl mx-auto" data-id="element-370">
          {/* Image Side */}
          <div className="mb-12 lg:mb-0 relative" data-id="element-371">
            <div className="relative rounded-3xl overflow-hidden shadow-xl border-8 border-cream" data-id="element-372">
              <img src="https://cdn.magicpatterns.com/uploads/98trXg9cf3YQCrBoQCnage/mujersonriente.png" alt="Mujer sonriente y saludable" className="w-full h-auto object-cover" data-id="element-373" />
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-gold/20 rounded-full blur-2xl -z-10" data-id="element-374"></div>
          </div>

          {/* Content Side */}
          <div data-id="element-375">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-sage mb-8 leading-tight" data-id="element-376">
              ¿Te despertás plana pero terminás el día como un globo?
            </h2>

            <div className="space-y-6 text-lg text-sage/80 mb-10" data-id="element-377">
              <p data-id="element-378">
                Después de los 40, tu cuerpo cambia. El Complejo Motor
                Migratorio (CMM) —el sistema de limpieza natural de tu
                intestino— se vuelve más lento.
              </p>
              <p data-id="element-379">
                No importa cuántas ensaladas comas o cuánta agua tomes. Si tu
                CMM está "apagado", la comida fermenta, genera gases y te
                inflama.
              </p>
            </div>

            <div className="bg-cream rounded-2xl p-8 mb-10 border border-sage/10" data-id="element-380">
              <ul className="space-y-5" data-id="element-381">
                {painPoints.map((point, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-382">
                    <div className="mt-1 bg-sage/10 p-1 rounded-full flex-shrink-0" data-id="element-383">
                      <Check className="w-5 h-5 text-sage" data-id="element-384" />
                    </div>
                    <span className="text-sage font-medium" data-id="element-385">{point}</span>
                  </li>)}
              </ul>
            </div>

            <div className="border-l-4 border-gold pl-6 py-2" data-id="element-386">
              <p className="text-2xl font-serif italic text-sage font-semibold" data-id="element-387">
                "La fuerza de voluntad se agota; la información no."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}